
import React from "react";
import "./StandardCleaningService.css";

const StandardCleaningService = () => {
  return (
    <div className="standard-cleaning-container">
      <h1>Consistent, Reliable Clean for Everyday Living</h1>
      <p>
        Our Standard Cleaning service is perfect for maintaining a clean, comfortable,
        and welcoming home on a regular basis. Whether you’re a busy professional, a parent juggling multiple tasks,
        or someone who simply values a tidy space, our standard cleanings are designed to keep your home in great shape week after week.
      </p>
      <p>
        This service is ideal for clients who don’t need a deep or detailed clean every time but still want a professional
        touch to maintain cleanliness and order. It can be scheduled weekly, bi-weekly, or monthly, depending on your needs and lifestyle.
      </p>

      <h2>What’s Included in Our Standard Cleaning Service?</h2>
      <ul>
        <li>✔ General dusting of surfaces and furniture</li>
        <li>✔ Vacuuming carpets and rugs</li>
        <li>✔ Sweeping and mopping hard floors</li>
        <li>✔ Cleaning and sanitizing bathroom sinks, toilets, mirrors, and counters</li>
        <li>✔ Wiping kitchen counters and external appliance surfaces</li>
        <li>✔ Emptying trash bins and replacing liners</li>
        <li>✔ Light tidying of living areas and bedrooms</li>
        <li>✔ Making beds (upon request)</li>
        <li>✔ Wiping down high-touch areas (like light switches and doorknobs)</li>
      </ul>
      <p><strong>Note:</strong> This service does not include deep scrubbing, heavy build-up removal, or inside appliances/cabinets — for that, we recommend our Deep Cleaning service.</p>

      <h2>Why Choose Us for Standard Cleaning?</h2>
      <ul>
        <li>🧼 <strong>Professional Results, Every Time</strong> – We bring consistency, care, and professionalism to every visit — your home will always look its best.</li>
        <li>📅 <strong>Flexible Scheduling</strong> – Choose weekly, bi-weekly, or monthly service that fits seamlessly into your routine.</li>
        <li>👥 <strong>Trusted & Friendly Staff</strong> – Our experienced cleaners are background-checked, fully trained, and dedicated to your satisfaction.</li>
        <li>🧽 <strong>Attention to What Matters</strong> – We clean with purpose focusing on high use, high traffic areas that make the biggest impact.</li>
        <li>❤ <strong>Customer First Service</strong> – Your comfort, preferences, and feedback matter. We’re always happy to customize our service to meet your expectations.</li>
      </ul>
    </div>
  );
};

export default StandardCleaningService;
